import { dispatch } from '@rematch/core';
import { store } from '../state';
import { push } from "react-router-redux";
export default function registerSocketService(app) {
    /** Email verification auto-login */
    app.service('accountusers').on('emailVerified', data => {
        const pendingUserId = store.getState().login.pendingVerificationUserId;
        console.log("Email verified event received for userId:", data.userId, "Pending userId:", pendingUserId);
        if (pendingUserId && data.userId === pendingUserId) {
            dispatch.login.autoLoginWithToken({
                userId: data.userId,
                autoLoginToken: data.autoLoginToken,
            });
        }
    });

    /** account related socket operations */
    app.service('accounts').on('patched', async data => {
        dispatch.account.updateSelectedAccountState(data);
        dispatch.account.getAllAccounts(data.ownerId);
        dispatch.platform.updateAccountList(data);
    });

    /** User related socket operartions */
    app.service('accountusers').on('UserLogin', data => {
        dispatch.platform.setActiveSessions(data.activeSessions);
    });
    app.service('accountusers').on('created', data => {
        dispatch.platform.getStats();
    });

    /** Notifications related socket operations */
    app.service('notifications').on('notificationCreated', async data => {
        dispatch.notifications.fetchNotificationIfNeeded(data)
    });

    /** AccountUSerWorkspace related socket operations */
    app.service('accountuserworkspaces').on('patched', data => {
        dispatch.organizationUnit.updateWorkspaceInState(data);
    });

    /** organizations related socket operations */
    app.service('organizations').on('created', data => {
        dispatch.platform.getStats();
    }).on('patched', async data => {
        let appState = store.getState().app;
        if(appState.selectedOrganisation && appState.selectedOrganisation._id && appState.selectedOrganisation._id.toString() === data._id.toString()){
            data.id = data._id;
            data.role = appState.selectedOrganisation.role;
           await dispatch.app.setSelectedOrganisationData(data);
        }
        const { accountId, _id } = data;
        dispatch.account.updateOrganizationList(data);
        // dispatch.organizationTab.getUsersTreeAsync({ id: _id, accountId: accountId, organizationId: _id });
        dispatch.organizationTab.getCurrentOrganizationData(_id)
    });

    app.service('organizations/active').on('patched', data => {
        let appState = store.getState().app;
        const payload = {
            appState: appState,
            data: data
        }
        dispatch.organizationUnit.isWorkspaceActiveCheck(payload);
    });

    app.service('organizations').on('changeRolepopup', data => {

        let appState = store.getState().app;
        const payload = {
            appState: appState,
            data: data
        }
        dispatch.organizationUnit.onChangeRedirectToWorkspace(payload)
        let query = {
            "$sort": {
                "name": 1
            },
            "$skip": 0,
            "$limit": 10
        }
        dispatch.account.getAcountUserWorkspaces(query);
    });
    app.service('suborganizations').on('patched', data => {
        dispatch.initiatives.updateOrganizationusers(data);
    });

    /** content related socket oerations */
    app.service('contents').on('created', async data => {
        let appState = store.getState();
        dispatch.platform.getStats();
        let payloadObj = {};
        payloadObj.organizationId = data.organizationId.toString();
        payloadObj.accountId = data.accountId.toString();
        payloadObj.userid = data.author.toString();
        await dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": payloadObj.accountId });
        await dispatch.content.getContentListData({ 
            query: appState.app.tableFilterQuery,
            params: { ...appState.app.routeParams, status: appState.app.routeParams.status }
        });
        await dispatch.content.setCategory([]);
        await dispatch.content.setSubCategory([]);
        await dispatch.content.getContentsCount({ organizationId: payloadObj.organizationId, accountId: payloadObj.accountId, 'value': 'All' });
        // if(store.getState().app.helpContext != "Add Content"){
        //     // await dispatch.app.setRouteParams(store.getState().app.routeParams);
        //     // let access = store.getState().app.routeParams.status === "knowledgeBank" ? "Private" :
        //     // store.getState().app.routeParams.status === "publicKnowledgeBank" ? "Public" : "all"
        //     // await dispatch.categories.getCategoryTreeByAccess({ "accountId": payloadObj.accountId, access: "Private" });
        //     // await dispatch.app.setContentPath(store.getState().app.contentPath);
        //     return dispatch(push(store.getState().app.contentPath ? `/app/${payloadObj.accountId}/_ws/${payloadObj.organizationId}/_ct/${store.getState().app.contentPath.split('_ct/')[1]}` : `/app/${payloadObj.accountId}/_ws/${payloadObj.organizationId}/_ct/status/contentLibrary`));
        // }
        // await dispatch.lifeCycle.getCategoryTreeAsync({"accountId": payloadObj.accountId});
        // if(store.getState().app.helpContext != "Add Content"){
        // dispatch.content.getAllContentsByBaseCategory({ organizationId: payloadObj.organizationId });
        // }

        // return dispatch(push('/app/60238c3af8fb411965ad4c03/_ws/60238c3af8fb411965ad4c06/_ct/status/knowledgeBank'));
        ///app/60238c3af8fb411965ad4c03/_ws/60238c3af8fb411965ad4c06/_ct/status/knowledgeBank
    }).on('publicAccessRevoked', data => {
        let appState = store.getState().app;
        if (appState.currentContext === 'content') {
            dispatch.content.updateContentListAndSelectedContent(data);
        }
    }).on('patched',async data => {
        let appState = store.getState().app;
        if (appState.currentContext === 'designer') {
            dispatch.content.updateContentInSelectedPlaybook(data);
            dispatch.createPack.updateRefInSelectedActivity(data);
            dispatch.createPack.updateSingleContent(data);
        }
        if (appState.currentContext === 'content') {
            dispatch.content.updateContentListAndSelectedContent(data);
            let dataWithId = data;
            dataWithId.id = dataWithId._id
            dispatch.content.setSingleContent(dataWithId)
        }
        await dispatch.platform.getStats();//KLM-8209
        await dispatch.content.getContentsCount({
            organizationId: appState.selectedOrganisation.id,
            accountId: appState.selectedAccount._id,
            value: "All",
        });
        dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": data.accountId });
    }).on('removed', async data => {
        let payloadObj = {};
        payloadObj.accountId = data.accountId.toString();
        await dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": payloadObj.accountId });
        let appState = store.getState().app;
        if (appState.currentContext === 'content') {
            dispatch.content.removeContetnFromContentList(data);
        }
    }).on('bulkImport', async data => {
        let payloadObj = {};
        payloadObj.accountId = data.accountId.toString();
        await dispatch.categories.getCategoryTreeByAccess({ "accountId": payloadObj.accountId });
        await dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": payloadObj.accountId });
    }).on('updateContentsForSocket', async data => {
        let payloadObj = {};
        payloadObj.accountId = data.accountId.toString();
        await dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": payloadObj.accountId });
    }).on('bulkPatch', async data => {
        let patchedData = data.patchedData.data
        let appState = store.getState().app;
        for(let content of patchedData){
            if (appState.currentContext === 'designer') {
                dispatch.content.updateContentInSelectedPlaybook(content);
                dispatch.createPack.updateRefInSelectedActivity(content);
                dispatch.createPack.updateSingleContent(content);
            }
            if (appState.currentContext === 'content') {
                dispatch.content.updateContentListAndSelectedContent(content);
                let dataWithId = content;
                dataWithId.id = dataWithId._id
                dispatch.content.setSingleContent(dataWithId)
                
            }
        }
        await dispatch.content.getContentsCount({
            organizationId: appState.selectedOrganisation.id,
            accountId: appState.selectedAccount._id,
            value: "All",
        });
        dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": appState.selectedAccount._id });
    }).on('bulkDelete', async data => {
        let patchedData = data.patchedData.data
        let appState = store.getState().app;
        dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": appState.selectedAccount._id });
        for(let content of patchedData){
            if (appState.currentContext === 'designer') {
                dispatch.content.updateContentInSelectedPlaybook(content);
                dispatch.createPack.updateRefInSelectedActivity(content);
                dispatch.createPack.updateSingleContent(content);
            }
            if (appState.currentContext === 'content') {
              //  dispatch.content.updateContentListAndSelectedContent(content);
                let dataWithId = content;
                dataWithId.id = dataWithId._id
             //   dispatch.content.setSingleContent(dataWithId)
                
            }
        }
        await dispatch.content.getContentsCount({
            organizationId: appState.selectedOrganisation.id,
            accountId: appState.selectedAccount._id,
            value: "All",
        });
    });

    /** playbook related socket operations */
    app.service('playbooks').on('created', async data => {
        let lifeCycleState = store.getState().lifeCycle
        dispatch.platform.getStats();
        let payloadObj = {};
        payloadObj.accountId = data.accountId.toString();
        await dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": payloadObj.accountId });
        await dispatch.lifeCycle.getPublicCategoryTreeAsync({ "accountId": payloadObj.accountId })
    });
    app.service('playbooks').on('activityDuplicated', data => {
        dispatch.lifeCycle.activityDupliacted(data);
    });
    app.service('playbooks').on('patched', async data => {
        let appState = store.getState().app;
        let lifeCycleState = store.getState().lifeCycle
        if (appState.currentContext === 'designer' && appState.selectedOrganisation && appState.selectedOrganisation.id && appState.selectedOrganisation.id.toString() === data.organizationId.toString()) {
            if ((appState.routeParams.status === "Generating" && data.status === -1) || data.status !== -1) {
                await dispatch.lifeCycle.newPlaybookTOPackList(data);
            }
        }
        await dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": data.accountId });
        await dispatch.lifeCycle.getPublicCategoryTreeAsync({ "accountId": data.accountId });
        if(appState.routeParams.status === "Generating" && data.status === 0){
            await dispatch.lifeCycle.setFilterByStatus(["-1"]);
            await dispatch.lifeCycle.getPacksByStatusArray({ organizationId: appState.selectedOrganisation.id, status: lifeCycleState.filterByStatus, accountUserId: appState.user._id, role: appState.selectedOrganisation.role })
        }
    });
    app.service('playbooks').on('removed', async data => {
        await dispatch.platform.getStats();
        dispatch.lifeCycle.throwOtherUsersOnNotFound(data);
    });
    app.service('playbooks').on('timeStampUpdated', data => {
        dispatch.lifeCycle.updatePlaybookTimeStamp(data);
    })
    /** playbook activities related socket operations */

    app.service('playbooks/activities').on('patched', data => {
        data.isSocket = true;
        dispatch.createPack.updateActivityInPlaybook(data);
        const lifeCycleState = store.getState().lifeCycle;
        const playbook = lifeCycleState.selectedPracticeLibrary
        if(playbook && playbook._id === data.packId){
        if(playbook && playbook.playbookGenerationStatus && playbook.playbookGenerationStatus === 1)
            dispatch.lifeCycle.getActivitiesCompletionPercentage();
        } else {
            dispatch.lifeCycle.getActivitiesCompletionPercentage(data);
        }  
        dispatch.createPack.updateInSummaryDataInSummaryView(data);
        dispatch.createPack.updateSingleContent(data);
    });
    app.service('playbooks/activities').on('activityDeleted', data => {
        dispatch.createPack.removeActivityFromPlaybook(data);
        dispatch.createPack.updateInSummaryDataInSummaryView(data);
    });
    app.service('playbooks/activities').on('practiceActivityCreated', data => {
        dispatch.lifeCycle.insertActivityInParent(data);
    });
    app.service('initiatives').on('initiativeInEditOrRemove', data => {
        let appState = store.getState().app;
        let routePayload = {};
        routePayload.initiativeData = data.initiativeData;
        routePayload.routeParams = appState.routeParams;
        routePayload.appState = appState;
        routePayload.initiativesState = store.getState().initiatives;
        routePayload.userName = data.userName;
        routePayload.userId = data.userId;
        dispatch.initiatives.routeWhenClickedInitiativeEdit(routePayload)
    });
    app.service('initiatives').on('initiativeRemoved', data => {
        let appState = store.getState().app;
        let routePayload = {};
        routePayload.initiativeData = data.initiativeData;
        routePayload.routeParams = appState.routeParams;
        routePayload.appState = appState;
        routePayload.initiativesState = store.getState().initiatives;
        routePayload.userName = data.userName;
        routePayload.userId = data.userId;
        dispatch.initiatives.routeAftercancelInitiativeEdit(routePayload)
    });
    app.service('initiatives').on('initiativeDeleted', data => {
        let appState = store.getState().app;
        let routePayload = {};
        routePayload.initiativeData = data.initiativeData;
        routePayload.routeParams = appState.routeParams;
        routePayload.appState = appState;
        routePayload.userName = data.userName;
        routePayload.userId = data.userId;
        dispatch.initiatives.routeAfterDeletingInitiative(routePayload)
    });
    app.service('initiatives').on('initiativeEditCompletedOrRestartInitiative', data => {
        let appState = store.getState().app;
        let routePayload = {};
        routePayload.initiativeData = data.initiativeData;
        routePayload.routeParams = appState.routeParams;
        routePayload.appState = appState;
        routePayload.copyId = data.copyId;
        routePayload.initiativesState = store.getState().initiatives;
        routePayload.userName = data.userName;
        routePayload.userId = data.userId;
        dispatch.initiatives.routeAfterInitiativeEditCompletedOrRestartInitiative(routePayload)
    });
    app.service('playbooks/activities').on('practiceActivityDragged', data => {

        dispatch.createPack.changeActivityPosition(data);
    });

    /** playbook communities related socket operations */
    app.service('playbooks/communities').on('patched', data => {
        dispatch.createPack.updateCommunityInPlaybook(data);
    }).on('communityDraggedSameParent', data => {
        dispatch.createPack.changeCommunityPosition(data);
    });
    app.service('playbooks/communities').on('removed', data => {
        dispatch.createPack.removeCommunityFromPlaybook(data);
    });
    app.service('playbooks/communities').on('practiceCommunityCreated', data => {
        dispatch.lifeCycle.insertCommunityInParent(data);
    });

    /** initiative related socket operations */
    app.service('initiatives').on('initiativeUpdated', data => {
        dispatch.initiatives.updateSelectedDataById(data);
    });
    app.service('initiatives').on('patched', async data => {
        delete data.activities;
        delete data.communities;
        //delete data.notes;
        dispatch.initiatives.updateSelectedDataById(data);
        dispatch.initiatives.updateInitiativeListAndCount(data);
        let payload = {}
        payload.organizationId = data.organizationId
        dispatch.initiatives.getinitiativesCount(payload);
        let appState = store.getState().app, initiativesState = store.getState().initiatives
        if (initiativesState.activeTab === "myactivities" && data.status === 3 && appState.selectedOrganisation && appState.selectedOrganisation.id && appState.selectedOrganisation.id.toString() === data.organizationId.toString()) {
            let payload = {
                organizationId: data.organizationId,
                userId: appState.user._id
            }
            dispatch.initiatives.getInitiativeActivitiesForMember(payload);
        }
    });
    app.service('initiatives').on('removed', data => {
        dispatch.initiatives.checkForDeletedInitiative(data)
        let payload = {}
        payload.organizationId = data.organizationId
        dispatch.initiatives.getinitiativesCount(payload);
    });

    /** initiative activities related dsocket operations */
    app.service('initiatives/activities').on('activityUpdated', data => {



        let appState = store.getState().app;
        data.data.isSocket = true;
        let initiativesState = store.getState().initiatives
        dispatch.initiatives.updateActivityInSelectedDataById(data.data);
        if (data.data.userId && appState.user._id != data.data.userId && initiativesState.activeTab === "myactivities" && appState.selectedOrganisation && appState.selectedOrganisation.id && data.organizationId && appState.selectedOrganisation.id.toString() === data.organizationId.toString()) {
            let objectRequiredToFetchAllInitiativeActivitiesForMember = {
                "accountId": data.data.accountId,
                "organizationId": data.data.organizationId,
                "userId": appState.user._id
            }
            dispatch.initiatives.getInitiativeActivitiesForMember(objectRequiredToFetchAllInitiativeActivitiesForMember);
        }
        // Member view - initiatives count
        if (initiativesState.activeTab === "myactivities" && appState.selectedOrganisation && appState.selectedOrganisation.id && appState.selectedOrganisation.id.toString() === data.data.organizationId.toString()) {
            dispatch.initiatives.getInitiativesCountForMember({ organizationId: data.data.organizationId })
            dispatch.initiatives.updateActivityInMyActivities(data.data);
        }        
    });
    app.service('initiatives/activities').on('activityCreated', data => {
        dispatch.initiatives.insertActivityInParent(data.data);
    });
    app.service('initiatives/activities').on('activityRaciUpdated', data => {
        dispatch.initiatives.updateSelectedActivity(data.updatedActivities);
    });
    app.service('initiatives/activities').on('activityUserChanged', data => {
        dispatch.initiatives.updateRaciCount(data);
    })
    /** initiative communities related socket operations */
    app.service('initiatives/communities').on('associatedActivityRaciUpdated', data => {
        data.communityId = data._id;
        dispatch.initiatives.updateCommunity(data);
    });

    /** tag related operations */
    app.service('tags').on('created', data => {
        dispatch.account.addNewTag(data);
        dispatch.templates.refreshTagsTree(data);
    }).on('removed', data => {
        dispatch.account.removeTagFromList(data);
        dispatch.templates.refreshTagsTree(data);
    }).on('patched', data => {
        dispatch.account.updateTagInList(data);
        dispatch.templates.refreshTagsTree(data);
    })

    /** Templates related operations */
    app.service('templates').on('created', data => {
        dispatch.templates.updateTemplateList(data);
    })

    /* Invite related operations */
    app.service('invites').on('patched', data => {
        if (data.referenceCollection === 'accounts' || data.referenceCollection === 'suborganizations' || data.referenceCollection === 'organizations') {
            dispatch.account.getInviteByAccountIdAsync(data.accountId)
        }
        if (data.isAccepted) {
            dispatch.invite.updateInviteList(data);
        }
        dispatch.invite.updateStateForResource(data);
    });

    app.service('invites').on('removed', data => {
        if (data.referenceCollection === 'accounts' || data.referenceCollection === 'suborganizations' || data.referenceCollection === 'organizations') {
            dispatch.account.getInviteByAccountIdAsync(data.accountId)
        }
        else {
            dispatch.invite.updateInviteList(data);
        }
    });

    app.service('declinedinvites').on('created', data => {
        dispatch.account.getInviteByAccountIdAsync(data.accountId)
    });


    /** commander dashboard related operations*/
    app.service('dashboards/concepts').on('created', data => {
        dispatch.dashboards.addConceptInDashboard(data)
    }).on('patched', data => {
        dispatch.dashboards.updateConceptInDashboard(data);
    }).on('removed', data => {
        dispatch.dashboards.removeConceptFromDashboard(data);
    })
    app.service('dashboards/events').on('created', data => {
        dispatch.dashboards.addEventInDashboard(data)
    }).on('removed', data => {
        dispatch.dashboards.removeEventFromDashboard(data);
    })
    app.service('dashboards').on('patched', data => {
        delete data.concepts;
        delete data.events;
        delete data.tagTree
        dispatch.dashboards.updateSelectedDashboard(data);
    })
    app.service('categories').on('created', data => {

        if (data.isPublic) {
            dispatch.lifeCycle.getPublicCategoryTreeAsync();
        }
        else {
            dispatch.account.setIsCategoryChange(true)
            dispatch.lifeCycle.getCategoryTreeAsync();
        }
        data.socketAction = "create"
        dispatch.categories.socketRefresh(data)
    }).on('patched', data => {
        if (data.isPublic) {
            dispatch.lifeCycle.getPublicCategoryTreeAsync();
        }
        else {
            dispatch.account.setIsCategoryChange(true)
            dispatch.lifeCycle.getCategoryTreeAsync();
        }
        data.socketAction = "patched"
        dispatch.categories.socketRefresh(data)
    }).on('bulkImport', data => {
        if (data.categoriesArray.length > 0 && data.accountId) {
            dispatch.lifeCycle.getCategoryAsync({ "accountId": data.accountId });
            dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": data.accountId });
        }
        dispatch.categories.getAllCategories()
    }).on('removed', data => {
        if (data.isPublic) {
            dispatch.lifeCycle.getPublicCategoryTreeAsync();
        }
        else {
            dispatch.account.setIsCategoryChange(true)
            dispatch.lifeCycle.getCategoryTreeAsync();
        }
        data.socketAction = "removed"
        dispatch.categories.socketRefresh(data)
    }).on('categoryCopied', data => {
        dispatch.lifeCycle.getCategoryTreeAsync();
        dispatch.account.setIsCategoryChange(true)
        // dispatch.categories.getAllCategories()
        data.socketAction = "categoryCopied"
        dispatch.categories.socketRefresh(data)

    }).on('defaultMarked', data => {
        dispatch.lifeCycle.getCategoryTreeAsync();
        dispatch.account.setIsCategoryChange(true)
        dispatch.categories.getAllCategories()
    });

    // integrations related socket services
    app.service('integrations').on('created', data => {
        dispatch.integrations.getIntegrations()
    }).on('patched', data => {
        dispatch.integrations.getIntegrations()
    }).on('removed', data => {
        dispatch.integrations.getIntegrations()
    })

    // Custom Templates related socket services
    app.service('customtemplates').on('created', data => {
        dispatch.customTemplates.fetchTemplates();
    }).on('patched', data => {
        dispatch.customTemplates.fetchTemplates();
    }).on('removed', data => {
        dispatch.customTemplates.fetchTemplates();
    })
}
